import { useRecoilState } from 'recoil';
import portList from 'recoil/atoms/portList';
import { PortData, PortModel } from 'models/PortModel';
import Api from 'utils/api';
import { replaceItemAtIndex } from 'utils/common';


const usePorts = () => {
    const [ports, setPorts] = useRecoilState(portList);

    const createPort = (port: PortData) => Api.ports.create(port)
        .then(res => {
            setPorts(old => [res.data, ...old]);
            return res.data.id;
        });

    const updatePort = (port: PortModel) => Api.ports.update(port)
        .then(res => setPorts(old => replaceItemAtIndex(old, old.findIndex(i => i.id === port.id), res.data)));

    return {
        loadingPorts: ports.filter(p => p.isLoading),
        destinationPorts: ports.filter(p => !p.isLoading),
        createPort,
        updatePort,
    }
};

export default usePorts;
